import Vue from 'vue'
import DateFormat from './date-format'
import MoneyFormat from './money-format'
import StrFormat from './str-format'

// 全局注册过滤器
Vue.use(DateFormat)
Vue.use(MoneyFormat)
Vue.use(StrFormat)

export function addressMap(orderType) {
  switch (orderType) {
    case '10':
    case '22' :
    case '28' :
      return '工程地址'
    case '11' :
    case '23' :
    case '29' :
      return '服务地址'
    case '12' :
      return '出租地址'
    default : return '收货地址'
  }
}
export function deliverTimeMap(orderType) {
  switch (orderType) {
    case '10':
    case '22' :
    case '28' :
      return '工程期限'
    case '11' :
    case '23' :
    case '29' :
      return '服务期限'
    case '12' :
      return '完成时间'
    default : return '送货时间'
  }
}
export function installationsMap(orderType) {
  switch (orderType) {
    case '10':
    case '22' :
    case '28' :
      return '工程要求'
    case '11' :
    case '23' :
    case '29' :
      return '服务要求'
    default : return '项目要求'
  }
}




// WEBPACK FOOTER //
// ./src/filters/index.js